function initproductMediaSlider () {
  const productMediaSlider = document.querySelector('.product-media-slider');
  const productMediaThumbnails = document.querySelector('.product-media-thumbnails');

  if (!productMediaSlider || !productMediaThumbnails) return;

  const { sectionId, mediaLength } = productMediaSlider.dataset;

  const mainSlider = new Swiper(productMediaSlider, {
    slidesPerView: 1,
    navigation: {
      nextEl: `.swiper-button-next--${sectionId}`,
      prevEl: `.swiper-button-prev--${sectionId}`
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });

  const thumbnailSlider = new Swiper(productMediaThumbnails, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    slideToClickedSlide: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: 'vertical',
    height: 144
  });

  mainSlider.controller.control = thumbnailSlider;
  thumbnailSlider.controller.control = mainSlider;
}

initproductMediaSlider();